import { useLocation, useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ClipboardList, Construction } from "lucide-react";

export default function PlannedModule() {
  const { moduleSlug } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const title = params.get("title") || "Modul Baru";
  const status = params.get("status") || "Direncanakan";
  const verified = status.toLowerCase().includes("verifikasi");

  return (
    <main className="page-shell mx-auto w-full max-w-6xl p-4 md:p-6" data-testid="planned-module-page">
      <div data-workspace-redundant-header className="mb-5 flex items-start gap-3">
        <div className="rounded-xl bg-orange-100 p-3 text-orange-700">
          <ClipboardList className="h-6 w-6" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Mazboy Hub · Workspace Modul</p>
          <h1 className="mt-1 text-2xl font-bold text-slate-900">{title}</h1>
          <p className="mt-1 text-sm text-slate-500">Kerangka halaman untuk tahap pengembangan berikutnya.</p>
        </div>
        <Badge variant="outline">{status}</Badge>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Construction className="h-5 w-5 text-orange-600" />
            {verified ? "Menunggu verifikasi kebutuhan" : "Fungsi belum dibangun"}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm leading-6 text-slate-600">
            Menu ini sudah terdaftar dalam navigasi Mazboy Hub, tetapi fungsi operasionalnya belum tersedia.
            Tidak ada transaksi atau data yang dibuat oleh halaman ini.
          </p>
          <div className="mt-4 rounded-lg border border-dashed border-slate-300 bg-slate-50 p-3">
            <p className="text-xs text-slate-500">Identitas modul</p>
            <p className="mt-1 break-all font-mono text-xs text-slate-700">{moduleSlug}</p>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
